import script from "./CCustomerService.vue?vue&type=script&setup=true&lang=ts"
export * from "./CCustomerService.vue?vue&type=script&setup=true&lang=ts"

import "./CCustomerService.vue?vue&type=style&index=0&id=315c72f4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-315c72f4"]])

export default __exports__